import { Formik, Field, Form, ErrorMessage } from 'formik';
import { useState } from "react"
import Logo from './../images/Logo.webp';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import AuthIllustration from '../components/AuthIllustration';

function ForgotPassword (){
    const navigate = useNavigate();
    const [mail,setMail] = useState("");
    const [mailFlag, setMailFlag] = useState(false);
    
    const initialValues = {
        email:''
    };
    
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email("*Field should contain a valid e-mail")
            .required("*E-mail is required"),        
    });

    const validatUser = async (values, { setSubmitting }) => {    
        setSubmitting(true);  
        if (values.email.indexOf("@data-aces") !== -1 || values.email.indexOf("@kaitongo") !== -1) {
            try{
                const {data} = await axios.post(`${process.env.REACT_APP_BASE_URL}/resetRequest`, {
                    email: values.email
                })
                setMail(values.email)
                setSubmitting(false); 
                setMailFlag(true)           
            }catch(error){
                console.log(error)
                let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
                toast.error(errmsg)
                setSubmitting(false);
            }
        } else {
            setSubmitting(false);
            alert("Error! Please enter valid email");
        }                        
    }

    return (
        <div className="relative flex min-h-screen w-full items-center justify-center overflow-hidden px-4 py-6 sm:px-6 lg:px-8">
            <div className="relative z-10 mx-auto grid w-full max-w-6xl gap-8 xl:gap-16 lg:grid-cols-2 lg:items-center">
                {/* Left side text */}
                <div className="hidden lg:flex flex-col lg:pl-10 xl:pl-16">
                    <div className="flex items-center justify-start w-full mb-8">
                        <img src={Logo} alt="Data Aces Logo" className="h-10 w-fit" />
                    </div>
                    
                    <h1 className="text-4xl font-bold text-slate-800 mb-2">Forgot Password?</h1>
                    <h2 className="text-3xl font-bold text-orange-500 mb-4 flex items-center gap-2">Let's get you back in 🔐</h2>
                    <div className="w-12 h-1 bg-orange-500 mb-6 rounded-full"></div>
                    
                    <p className="text-slate-500 mb-8 text-base">
                        Enter your email address and we'll send you a link<br/>
                        to securely reset your password.
                    </p>
                </div>

                {/* Right side form */}
                <div className="self-center bg-white rounded-2xl border border-slate-200 shadow-sm p-8 md:p-10 w-full max-w-md mx-auto relative">
                    
                    <div className="flex justify-center mb-6 lg:hidden">
                        <img src={Logo} alt="Data Aces Logo" className="h-10" />
                    </div>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={validatUser}
                    >
                        {({ isSubmitting }) => (
                            <>
                                {mailFlag ? (
                                    <div className="text-center flex flex-col items-center">
                                        <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-6">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                                        </div>
                                        <h2 className="text-2xl font-bold text-slate-800 mb-2">Request sent successfully</h2>
                                        <p className="text-slate-500 mb-8 text-sm leading-relaxed">
                                            We have sent a password reset link to <br/><span className="font-bold text-slate-700">{mail}</span>.<br/>Please check your mailbox.
                                        </p>
                                        <button type="button" onClick={() => navigate('/login')} className="w-full flex items-center justify-center gap-2 py-3 bg-white text-slate-700 border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors font-semibold text-sm shadow-sm">
                                            Back to Sign in
                                        </button>
                                    </div>
                                ) : (
                                    <Form className="space-y-6">
                                        <div>
                                            <h2 className="text-2xl font-bold text-slate-800 mb-2">Forgot Password</h2>
                                            <p className="text-slate-500 mb-2 text-sm">Please enter the email address associated with your account.</p>
                                        </div>

                                        <div className="pt-2">
                                            <label className="block text-sm font-semibold text-slate-800 mb-2">Email Address</label>
                                            <div className="relative">
                                                <div className="absolute top-1/2 -translate-y-1/2 left-0 w-11 flex items-center justify-center pointer-events-none">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                                                </div>
                                                <Field autoFocus type="text" name="email" placeholder="Enter your email" className="w-full pl-11 pr-4 py-3 bg-white border border-slate-200 rounded-xl text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 hover:border-blue-500 transition-colors" />
                                            </div>
                                            <ErrorMessage name="email" component="div" className="text-red-500 text-xs mt-1"/>
                                        </div>

                                        <div className="flex flex-col gap-3 pt-4">
                                            <button type="submit" disabled={isSubmitting} className="w-full flex items-center justify-center gap-2 py-3 bg-[#2563eb] text-white rounded-xl hover:bg-blue-700 transition-colors font-semibold text-sm shadow-[0_4px_12px_rgba(37,99,235,0.2)]" style={{opacity: isSubmitting ? '0.7' : '1'}}>
                                                {isSubmitting ? (
                                                    <svg className="animate-spin mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>
                                                )}
                                                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                                            </button>
                                            
                                            <button type="button" onClick={() => navigate('/login')} className="w-full flex items-center justify-center gap-2 py-3 bg-white text-slate-700 border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors font-semibold text-sm shadow-sm mt-1">
                                                Back to Sign in
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </>
                        )}
                    </Formik>
                </div>
            </div>
            
            <div className="fixed bottom-6 right-8 text-xs text-slate-400 font-medium flex items-center gap-1.5 z-20">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                © {new Date().getFullYear()} Data Aces. All rights reserved.
            </div>

            <AuthIllustration />
        </div>
    )
};
export default ForgotPassword;
